export default "__VITE_ASSET__DiB0imv8__"